import { render, staticRenderFns } from "./ScoreCard.vue?vue&type=template&id=dbc1a2d8&"
import script from "./ScoreCard.vue?vue&type=script&lang=js&"
export * from "./ScoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports